import { Navigate } from 'react-router-dom';
import { useBusinessProfiles } from '../hooks/useBusinessProfiles';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Smart routing component for business profiles
 * - If user has existing profiles, redirect to the first one for editing
 * - If user has no profiles, show the creation form
 */
export default function BusinessProfileRouter() {
  const { data: businessProfiles, isLoading, error } = useBusinessProfiles();

  if (isLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <CircularProgress />
        <Typography>Loading your business profiles...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <Typography color="error">Error loading business profiles</Typography>
      </Box>
    );
  }

  // If user has existing profiles, redirect to the first one for editing
  if (businessProfiles && businessProfiles.length > 0) {
    const firstProfile = businessProfiles[0];
    return <Navigate to={`/business-profiles/${firstProfile.id}`} replace />;
  }

  // If user has no profiles, redirect to creation form
  return <Navigate to="/business-profiles/new" replace />;
}
